(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-custom"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nido-multicolumn-custom-v3')) {
  customElements.define('nido-multicolumn-custom-v3', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('[id^="Slider-"]');
      this.controls = this.querySelector('[data-carousel-controls]');
      if (!this.track || !this.controls) return;
      this.dots = this.querySelector('[data-carousel-dots]');
      this.previous = this.querySelector('[name="previous"]');
      this.next = this.querySelector('[name="next"]');
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.previous.addEventListener('click', () => this.go(this.active - 1), options);
      this.next.addEventListener('click', () => this.go(this.active + 1), options);
      this.dots.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-page]');
        if (dot) this.go(Number(dot.dataset.page));
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('.nido-multicolumn-slide');
        const index = this.slides?.indexOf(slide);
        if (index >= 0) this.go(Math.min(index, this.positions.length - 1));
      }, options);
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.track);
      Array.from(this.track.children).forEach((slide) => this.observer.observe(slide));
      window.addEventListener('resize', () => this.measure(), options);
      this.measure();
    }

    measure() {
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      const enabled = desktop ? this.dataset.desktopEnabled === 'true' : this.dataset.mobileEnabled === 'true';
      this.dataset.pagination = desktop ? this.dataset.desktopPagination : this.dataset.mobilePagination;
      this.slides = Array.from(this.track.children).filter((slide) => slide.matches('.nido-multicolumn-slide') && slide.getClientRects().length && slide.clientWidth > 0);
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.positions = [0];
      if (enabled && max > 2 && this.slides.length > 1) {
        const first = this.slides[0].offsetLeft;
        this.slides.slice(1).forEach((slide, index) => {
          const last = index === this.slides.length - 2;
          const position = last ? max : Math.min(max, Math.abs(slide.offsetLeft - first));
          if (position - this.positions[this.positions.length - 1] > 2) this.positions.push(position);
        });
      }
      this.controls.hidden = !enabled || this.positions.length < 2;
      if (this.dots.children.length !== this.positions.length) {
        this.dots.replaceChildren(...this.positions.map((position, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'slider-dot';
          button.dataset.page = String(index);
          button.setAttribute('aria-label', `${this.dataset.pageLabel} ${index + 1}`);
          button.setAttribute('aria-controls', this.track.id);
          return button;
        }));
      }
      this.querySelector('[data-carousel-total]').textContent = this.positions.length;
      this.update();
    }

    update() {
      if (!this.positions) return;
      const scroll = Math.abs(this.track.scrollLeft);
      this.active = this.positions.reduce((nearest, position, index) => Math.abs(position - scroll) < Math.abs(this.positions[nearest] - scroll) ? index : nearest, 0);
      this.querySelector('[data-carousel-current]').textContent = this.active + 1;
      this.previous.disabled = this.active === 0;
      this.next.disabled = this.active === this.positions.length - 1;
      Array.from(this.dots.children).forEach((dot, index) => dot.setAttribute('aria-current', index === this.active ? 'true' : 'false'));
    }

    go(index) {
      if (!this.positions) return;
      const page = Math.max(0, Math.min(this.positions.length - 1, index));
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollTo({ left: this.positions[page] * (rtl ? -1 : 1), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nido-multicolumn-carousel')) {
  customElements.define('nido-multicolumn-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('[id^="Slider-"]');
      this.controls = this.querySelector('[data-carousel-controls]');
      if (!this.track || !this.controls) return;
      this.dots = this.querySelector('[data-carousel-dots]');
      this.previous = this.querySelector('[name="previous"]');
      this.next = this.querySelector('[name="next"]');
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.previous.addEventListener('click', () => this.go(this.active - 1), options);
      this.next.addEventListener('click', () => this.go(this.active + 1), options);
      this.dots.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-page]');
        if (dot) this.go(Number(dot.dataset.page));
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('.slider__slide');
        const index = this.slides?.indexOf(slide);
        if (index >= 0) this.go(Math.min(index, this.positions.length - 1));
      }, options);
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.track);
      Array.from(this.track.children).forEach((slide) => this.observer.observe(slide));
      window.addEventListener('resize', () => this.measure(), options);
      this.measure();
    }

    measure() {
      const desktop = window.matchMedia('(min-width: 990px)').matches;
      const enabled = desktop ? this.dataset.desktopEnabled === 'true' : this.dataset.mobileEnabled === 'true';
      this.dataset.pagination = desktop ? this.dataset.desktopPagination : this.dataset.mobilePagination;
      this.slides = Array.from(this.track.children).filter((slide) => slide.matches('.slider__slide') && slide.getClientRects().length && slide.clientWidth > 0);
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.positions = [0];
      if (enabled && max > 2 && this.slides.length > 1) {
        const first = this.slides[0].offsetLeft;
        this.slides.slice(1).forEach((slide, index) => {
          const last = index === this.slides.length - 2;
          const position = last ? max : Math.min(max, Math.max(0, slide.offsetLeft - first));
          if (position - this.positions[this.positions.length - 1] > 2) this.positions.push(position);
        });
      }
      this.controls.hidden = !enabled || this.positions.length < 2;
      if (this.dots.children.length !== this.positions.length) {
        this.dots.replaceChildren(...this.positions.map((position, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'slider-dot';
          button.dataset.page = String(index);
          button.setAttribute('aria-label', `${this.dataset.pageLabel} ${index + 1}`);
          button.setAttribute('aria-controls', this.track.id);
          return button;
        }));
      }
      this.querySelector('[data-carousel-total]').textContent = this.positions.length;
      this.update();
    }

    update() {
      if (!this.positions) return;
      const scroll = Math.abs(this.track.scrollLeft);
      this.active = this.positions.reduce((nearest, position, index) => Math.abs(position - scroll) < Math.abs(this.positions[nearest] - scroll) ? index : nearest, 0);
      this.querySelector('[data-carousel-current]').textContent = this.active + 1;
      this.previous.disabled = this.active === 0;
      this.next.disabled = this.active === this.positions.length - 1;
      Array.from(this.dots.children).forEach((dot, index) => dot.setAttribute('aria-current', index === this.active ? 'true' : 'false'));
    }

    go(index) {
      if (!this.positions) return;
      const page = Math.max(0, Math.min(this.positions.length - 1, index));
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollTo({ left: this.positions[page] * (rtl ? -1 : 1), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('guarda-reviews-carousel')) {
  customElements.define('guarda-reviews-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.reviews-section__reviews');
      this.slides = [...this.querySelectorAll('[data-review-index]')];
      this.dots = [...this.querySelectorAll('[data-review-dot]')];
      if (!this.track || !this.slides.length) return;
      this.index = 0;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hovered = false;
      this.interacting = false;
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), options));
      this.track.addEventListener('scroll', () => {
        this.pause();
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
        clearTimeout(this.settle);
        this.settle = setTimeout(() => { this.fit(); this.start(); }, 160);
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        let next;
        if (event.key === 'ArrowRight') next = this.index + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') next = this.index + (rtl ? 1 : -1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.slides.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.go(next);
      }, options);
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.pause(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.start(); }, options);
      this.addEventListener('pointerdown', () => { this.interacting = true; this.pause(); }, options);
      const release = () => { this.interacting = false; this.start(); };
      window.addEventListener('pointerup', release, options);
      window.addEventListener('pointercancel', release, options);
      this.addEventListener('focusin', () => this.pause(), options);
      this.addEventListener('focusout', () => {
        clearTimeout(this.focusTimer);
        this.focusTimer = setTimeout(() => this.start(), 0);
      }, options);
      document.addEventListener('visibilitychange', () => this.start(), options);
      this.motion.addEventListener('change', () => this.start(), options);
      this.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('[data-review-index]');
        if (!slide || !this.contains(slide)) return;
        this.editorSelected = true;
        this.go(this.slides.indexOf(slide), 'auto');
        this.pause();
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.start(); }, options);
      this.width = this.track.clientWidth;
      this.observer = new ResizeObserver(() => {
        const width = this.track.clientWidth;
        if (width !== this.width) {
          this.width = width;
          this.go(this.index, 'auto');
        }
        this.fit();
      });
      this.observer.observe(this.track);
      this.slides.forEach(slide => this.observer.observe(slide));
      this.update();
      this.fit();
      this.start();
    }
    delta(slide) {
      const track = this.track.getBoundingClientRect();
      const rect = slide.getBoundingClientRect();
      return getComputedStyle(this.track).direction === 'rtl' ? rect.right - track.right : rect.left - track.left;
    }
    sync() {
      let nearest = 0;
      let distance = Infinity;
      this.slides.forEach((slide, index) => {
        const value = Math.abs(this.delta(slide));
        if (value < distance) { nearest = index; distance = value; }
      });
      this.index = nearest;
      this.update();
    }
    update() {
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      this.slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === this.index);
        slide.inert = index !== this.index;
      });
    }
    fit() {
      this.track.style.height = `${Math.ceil(this.slides[this.index].getBoundingClientRect().height)}px`;
    }
    go(index, behavior) {
      this.pause();
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.update();
      this.fit();
      this.track.scrollBy({ left: this.delta(this.slides[this.index]), behavior: behavior || (this.motion.matches ? 'auto' : 'smooth') });
      this.start();
    }
    pause() { clearInterval(this.timer); }
    start() {
      this.pause();
      const allowed = this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.motion.matches && !document.hidden && !this.hovered && !this.interacting && !this.contains(document.activeElement) && !this.editorSelected;
      this.track.setAttribute('aria-live', allowed ? 'off' : 'polite');
      if (!allowed) return;
      this.timer = setInterval(() => this.go((this.index + 1) % this.slides.length), Math.max(3, Number(this.dataset.autoplaySeconds) || 6) * 1000);
    }
    disconnectedCallback() {
      this.pause();
      clearTimeout(this.settle);
      clearTimeout(this.focusTimer);
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vale-comparison-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vale-comparison')) {
  customElements.define('vale-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.grid = this.querySelector('[data-grid]');
      this.dots = this.querySelector('.vale-comparison__dots');
      this.media = window.matchMedia('(max-width: 749px)');
      this.active = 1;
      this.dots.hidden = false;
      this.querySelectorAll('[data-select]').forEach(button => button.addEventListener('click', () => this.select(Number(button.dataset.select)), options));
      this.grid.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.select(this.active === 1 ? 2 : 1); } }, options);
      this.grid.addEventListener('pointerdown', event => { this.start = { x: event.clientX, y: event.clientY }; }, options);
      this.grid.addEventListener('pointerup', event => { if (!this.start || !this.media.matches) return; const dx = event.clientX - this.start.x; const dy = event.clientY - this.start.y; if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.select(dx < 0 ? 2 : 1); this.start = null; }, options);
      this.grid.addEventListener('pointercancel', () => { this.start = null; }, options);
      this.media.addEventListener('change', () => this.sync(), options);
      this.sync();
    }
    select(number) { this.active = number; this.sync(); }
    sync() {
      this.grid.dataset.active = String(this.active);
      this.grid.tabIndex = this.media.matches ? 0 : -1;
      this.querySelectorAll('[data-col]').forEach(cell => { if (this.media.matches && Number(cell.dataset.col) !== this.active) cell.setAttribute('aria-hidden', 'true'); else cell.removeAttribute('aria-hidden'); });
      this.querySelectorAll('[data-select]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.select) === this.active)));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
